"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitOpeningReadingHeader = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var components_1 = require("../../components");
var copy_1 = require("../../copy");
var SubmitOpeningReadingHeader = function (_a) {
    var isMissingMSN = _a.isMissingMSN, selectedFuel = _a.selectedFuel, supply = _a.supply, supplies = _a.supplies, latestOpeningReading = _a.latestOpeningReading;
    var _b = (0, core_1.useComponents)(), Heading1 = _b.Heading1, Pii = _b.Pii, SummaryList = _b.SummaryList, SummaryItem = _b.SummaryItem, Callout = _b.Callout;
    var _c = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _c.copy, Copy = _c.Copy;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Heading1, null,
            react_1.default.createElement(Copy, { copyKey: "omrSubmitPageHeading", values: { fuel: selectedFuel } })),
        isMissingMSN ? (react_1.default.createElement(core_1.Feature, { feature: "omrWithoutMsn" }, function (enabled) {
            return enabled ? (react_1.default.createElement(Callout, { "data-testid": "callout" },
                react_1.default.createElement(Copy, { copyKey: "submitPageMissingMSN" }))) : null;
        })) : null,
        react_1.default.createElement(SummaryList, null,
            isMissingMSN ? null : (react_1.default.createElement(SummaryItem, { label: copy('summaryMeterSerial'), "data-testid": "meter-reading-form_msn" },
                react_1.default.createElement(Pii, null, supply.msn))),
            supplies[selectedFuel].length > 1 && (react_1.default.createElement(SummaryItem, { label: selectedFuel === 'gas'
                    ? copy('summarySupplyPointSerialGas')
                    : copy('summarySupplyPointSerialElec'), "data-testid": "meter-reading-form_mpxn" },
                react_1.default.createElement(Pii, null, supply.mpxn))),
            latestOpeningReading && (react_1.default.createElement(SummaryItem, { label: copy('summaryLastRead', {
                    readDate: (0, date_fns_1.format)(latestOpeningReading.readingDateTime, 'd MMM'),
                }) },
                react_1.default.createElement(components_1.PreviousMeterReading, { fuel: selectedFuel, reading: latestOpeningReading, meterNumOfDigits: supply.meterNumOfDigits }))))));
};
exports.SubmitOpeningReadingHeader = SubmitOpeningReadingHeader;
